import { apiServiceConstants } from "../../constants/apiService.constants";
import { apiService } from "../../services/apiService";
import { utilService } from "../../services/utilService";
import {
  FileShareFullListInterface
} from "../FileShare/components/SelectUserComponent/SelectUserComponent.model";

const getMessageListData = async (params: any) => {
  const respApiResult = await apiService
    .apiCall(
      `user/messages/?reg_code=${utilService.getNetwork()}&search_text=${params?.searchQuery}&page=${params?.pageNumber}&time_zone=${params?.timezone}&n2n_network=${params?.n2nNetwork??""}`,
      {},
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      return res
    })
    .catch((err) => {
      const result: FileShareFullListInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};
// const getMessageListData = async (params: any) => {
//   const respApiResult = await apiService
//     .apiCall(
//       `user/message-media-list/?reg_code=${utilService.getNetwork()}`,
//       params,
//       apiServiceConstants.GET,
//       utilService.getDeviceType()
//     )
//     .then((res) => {
//       const messageListResp: any = res;
//       const messageListResponse = setMessageListModel(messageListResp);
//       const result = {
//         message: messageListResp.message,
//         status: messageListResp.status,
//         isSuccess: messageListResp.isSuccess,
//         result: messageListResponse[0],
//       };
//       return result;
//     })
//     .catch((err) => {
//       const result: FileShareFullListInterface = {
//         isSuccess: false,
//         message: err.message,
//         status: err.status,
//       };
//       return result;
//     });
//   return respApiResult;
// };

const fetchChatHistory =  async ({
  smsThreadId,
  page,
  timezone,
  guids,
  chatType,
  n2nNetwork
}: any) => {
  const respApiResult = await apiService
    .apiCall(
      `user/user-chat-messages/?reg_code=${utilService.getNetwork()}&sms_thread_id=${smsThreadId}&page=${page}&time_zone=${timezone}&guids=${guids}&chat_type=${chatType}&n2n_network=${n2nNetwork??""}`,
      {},
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      return res
    })
    .catch((err) => {
      const result: FileShareFullListInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const deleteChat =  async ({
  smsThreadId,
  ids,
  type,
  n2nNetwork
}: any) => {
  const respApiResult = await apiService
    .apiCall(
      `user/user-chat-messages/${smsThreadId}/?reg_code=${utilService.getNetwork()}&ids=${ids}&type=${type}&n2n_network=${n2nNetwork??""}`,
      {},
      apiServiceConstants.DELETE,
      utilService.getDeviceType()
    )
    .then((res) => {
      console.log("test msgs res",res)
      return res
    })
    .catch((err) => {
      const result: FileShareFullListInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const handleErrorResponse = () => {};

export const UserChatService = {
  getMessageListData,
  handleErrorResponse,
  fetchChatHistory,
  deleteChat
};
